import React from 'react'
import { Switch, Route } from 'react-router'

import { SETTINGS } from '../config/routes'
import withMainLayout from '../layouts/Main/withMainLayout'
import { OrdersetSettingsPage, ProfileSettingsPage, BillingSettingsPage } from '../pages/Settings'
import { BillingCloseCallback } from '../pages/Settings/BillingSettingsPage/view'

const SettingsRoutes = ({ path, me, loggedIn }) => (
  <Route
    path={path}
    render={() => (
      <Switch>
        <Route
          path={SETTINGS.orderset}
          render={() =>
            withMainLayout(OrdersetSettingsPage, {
              me,
              loggedIn,
            })
          }
        />
        <Route
          path={SETTINGS.newOrderset}
          render={() =>
            withMainLayout(OrdersetSettingsPage, {
              me,
              loggedIn,
            })
          }
        />
        <Route
          path={SETTINGS.editOrderset}
          render={() =>
            withMainLayout(OrdersetSettingsPage, {
              me,
              loggedIn,
            })
          }
        />
        <Route
          path={SETTINGS.profile}
          render={() =>
            withMainLayout(ProfileSettingsPage, {
              me,
              loggedIn,
            })
          }
        />
        <Route path={SETTINGS.billingClose} exact component={BillingCloseCallback} />
        <Route
          path={SETTINGS.billing}
          render={() =>
            withMainLayout(BillingSettingsPage, {
              me,
              loggedIn,
            })
          }
        />
      </Switch>
    )}
  />
)

export default SettingsRoutes
